import moment from "moment-timezone";

export const PROCESSING_STATUS = {
    NEED: 1,
    PENDING_APPROVAL: 2,
    REJECTED: 3,
    WAITING_REFUND: 4,
    COMPLETED: 5,
};

export const STATUS_OPTIONS = [
    {label: "Nhu cầu", value: PROCESSING_STATUS.NEED},
    {label: "Cần duyệt hoàn", value: PROCESSING_STATUS.PENDING_APPROVAL},
    {label: "Từ chối hoàn", value: PROCESSING_STATUS.REJECTED},
    {label: "Chờ hoàn", value: PROCESSING_STATUS.WAITING_REFUND},
    {label: "Hoàn thành", value: PROCESSING_STATUS.COMPLETED},
];

export class DepositRefundModel {
    constructor(row = {}) {
        this.id = row.id ?? null;
        this.contractId = row.contract_id ?? null;
        this.contractCode = row.contract_code ?? row.contract_id ?? "";
        this.studentCode = row.student_code ?? "";
        this.studentName = row.student_name ?? "";
        this.phone = row.phone ?? "";
        this.mainClassName = row.main_class_name ?? "";
        this.supplementaryClass1Name = row.supplementary_class_1_name ?? "";
        this.supplementaryClass2Name = row.supplementary_class_2_name ?? "";
        this.assignedStaffName = row.assigned_staff_name ?? "";
        this.absenceCount = row.absence_count ?? 0;
        this.homeworkMissingCount = row.homework_missing_count ?? 0;
        const bank = DepositRefundModel.resolveBankInfo(row);
        this.bankAccountNumber = bank.bankAccountNumber;
        this.bankAccountName = bank.bankAccountName;
        this.bankName = bank.bankName;
        this.userId = DepositRefundModel.resolveUserId(row);
        this.totalErrors = row.total_errors ?? 0;
        this.refundAmount = row.refund_amount;
        this.processingStatus = Number(row.processing_status ?? PROCESSING_STATUS.NEED);
        this.processingStatusLabel =
            row.processing_status_label ?? DepositRefundModel.statusLabel(this.processingStatus);
        this.refundedAt = DepositRefundModel.formatDateTime(row.refunded_at);
        this.createdAt = DepositRefundModel.formatDateTime(row.created_at ?? row.registered_at);
        this.raw = row;
    }

    get processingStatusClass() {
        switch (this.processingStatus) {
            case PROCESSING_STATUS.PENDING_APPROVAL:
                return "refund-status--pending";
            case PROCESSING_STATUS.REJECTED:
                return "refund-status--rejected";
            case PROCESSING_STATUS.WAITING_REFUND:
                return "refund-status--waiting";
            case PROCESSING_STATUS.COMPLETED:
                return "refund-status--completed";
            default:
                return "refund-status--need";
        }
    }

    get showRequestRefundAction() {
        return this.processingStatus === PROCESSING_STATUS.NEED;
    }

    get showApproveAction() {
        return (
            this.processingStatus === PROCESSING_STATUS.PENDING_APPROVAL ||
            this.processingStatus === PROCESSING_STATUS.WAITING_REFUND
        );
    }

    get showRejectAction() {
        return this.processingStatus === PROCESSING_STATUS.REJECTED;
    }

    static statusLabel(status) {
        const found = STATUS_OPTIONS.find((o) => o.value === Number(status));
        return found?.label ?? "";
    }

    static resolveUserId(row = {}) {
        if (row.user_id) return Number(row.user_id);
        if (row.user?.id) return Number(row.user.id);
        const studentCode = Number(row.student_code);
        if (!Number.isNaN(studentCode) && studentCode > 100000) {
            return studentCode - 100000;
        }
        return null;
    }

    static normalizeBankAccounts(bankAccounts) {
        if (!bankAccounts) return null;
        if (Array.isArray(bankAccounts)) return bankAccounts[0] ?? null;
        if (typeof bankAccounts === "object" && Object.keys(bankAccounts).length) {
            return bankAccounts;
        }
        return null;
    }

    static pickUserBank(source = {}) {
        const bank = DepositRefundModel.normalizeBankAccounts(source.bank_accounts);
        if (!bank) return null;
        const bankAccountNumber = bank.stk ?? bank.bank_account_number ?? "";
        const bankAccountName = bank.owner_name ?? bank.bank_account_name ?? "";
        const bankName = bank.ngan_hang ?? bank.bank_name ?? "";
        if (!bankAccountNumber && !bankAccountName && !bankName) return null;
        return {bankAccountNumber, bankAccountName, bankName};
    }

    static resolveBankInfo(row = {}) {
        const fromRefund = {
            bankAccountNumber: row.bank_account_number ?? "",
            bankAccountName: row.bank_account_name ?? "",
            bankName: row.bank_name ?? "",
        };
        if (fromRefund.bankAccountNumber || fromRefund.bankAccountName || fromRefund.bankName) {
            return fromRefund;
        }
        return DepositRefundModel.pickUserBank(row.user) ?? fromRefund;
    }

    static formatDateTime(value) {
        if (!value) return "";
        const m = moment(value);
        return m.isValid() ? m.format("HH:mm:ss DD/MM/YYYY") : value;
    }
}
